/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

// import components below
import Layout from 'components/Layout';
import PageHeader from './components/PageHeader';
import SideBar from 'components/ACLComponents/SideBar';
import LoansContainer from './components/LoansContainer';

// main component
const Loans = () => {
  return (
    <Layout pageTitle='Loans'>
      <PageHeader />

      <Row className='mt-4'>
        <Col sm={9}>
          <LoansContainer />
        </Col>
        <Col sm={3}>
          <SideBar />
        </Col>
      </Row>
    </Layout>
  );
};

export default Loans;
